<template>
    <div class="banner-set load border-golden">
        <div class="container border-golden">
        
        <div class="banners" v-touch:tap="touchHandler" >
        

        <a href="javascript:void(0);" :page="result.page_name"  class="banner" v-for="result in AllCategories" v-bind:key="result.id">
          
            <img  v-onload="result.image_path" width="270" v-bind:alt="result.title">
            <!-- <h2 style="text-align:center;" class="title">{{ result.title }}</h2>
            <div class="description hide">{{ result.description }}</div> -->
          
        </a>
        
        </div>
        <div style="#thumblist"></div>
        <div class="clearfix"></div>
        
    </div>
    <div class="nav-box">
        <div class="container">
        <a class="prev" href="#"><i class="icon-arrow-left"></i></a>
        <div class="pagination switches"></div>
        <a class="next" href="#"><i class="icon-arrow-right"></i></a>	
        </div>
    </div>

    </div>
</template>    
<script>
//import axios from 'axios'
import {mapGetters} from "vuex";
import Vue from 'vue'
import $ from 'jquery'
import Common from '@/common.js'
import OnLoad from 'vue-onload'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(OnLoad);
Vue.use(Vue2TouchEvents)



export default {
   data: function(){
    return {
    results: null
    }
  },  props: {
    msg: String
  },
  computed:mapGetters(["AllCategories"]),
  created(){
    this.getCategories;
},
watch:{
  AllCategories(newValue) {
      // Do whatever makes sense now
      //if (newValue.length > 0) {
          this.get_response(newValue)
      //}
  }
},
  mounted: function() {

    
    //Common.callServerFunction("Items/ItemController::GetCategory",this.get_response,{},"Item");

    //axios.get("http://localhost/api/categories.php")
    //.then(response => {this.results = response.data})
    
  },methods:{
          touchHandler (event) {
            
            //var purl   = $(event.target).attr('href');

            var attr = $(event.target).attr('page');

            if (typeof attr !== typeof undefined && attr !== false) {
                  //$(event.target).trigger("click");    
                  this.$router.push('/' + attr);
            }else{
                  //$(event.target).parent().trigger("click");
                  attr = $(event.target).parent().attr('page');
                  this.$router.push('/' + attr);
            }
            
            
            /*if(purl != undefined)
            { 
              this.$router.push({name:purl});
            }else
            {
              purl = $(event.target).parent().attr('href');
              this.$router.push({name:purl});
            }
            */
            

            //console.log($(event.target).parent())  // May be left / right / top / bottom
        },
          get_response:function(response)
          {	
            //var rdata = JSON.parse(response);
            var rdata = response;
            this.results = rdata;
            
            Common.startAjaxLoader();
                var jimage = [];
                rdata.forEach((item) => {
                    //console.log(item.image_path + " - " + index);
                    jimage.push(item.image_path)
                });
                this.preload = false
                this.$nextTick(function() {
                  this.$images.preload(jimage,
                    //(completed, progress) => {
                    (completed) => {  
                      // progress indicator from 0 (no image loaded yet) to 1 (all images loaded)
                      //console.log(Math.round(progress * 100))
                      // completed = true when all images are loaded
                      if (completed) {
                        this.preload = true
                        //console.log(completed);
                        eval('loadFunctions();loadSlider();');
                      }
                    }
                  )
                })

                //$(".item").eq(0).addClass('item active');


                          //$.get('./js/main.js', function(data) {
                        //eval(data);
                        //eval('setTimeout(loadFunctions(),1000);');

                //});
                Common.stopAjaxLoader();
         }   
   }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
